import React from "react"
import { useParams } from "react-router-dom"
import {
    Create,
    usePermissions,
} from "react-admin"
import { useTranslate } from "ra-core"
import BarChartIcon from "@mui/icons-material/BarChart"
import ScheduleIcon from "@mui/icons-material/Schedule"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import { ScheduleForm } from "components/schedule"

function ScheduleCreate(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()
    const translate = useTranslate()
    const { id } = useParams<{ id: string }>()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "devices", icon: <ScheduleIcon/> },
        { label: translate("resources.devices.data"), name: "data", resource: "devices", icon: <TableIcon/> },
        { label: translate("resources.devices.chart"), name: "chart", resource: "devices", icon: <BarChartIcon/> },
    ]

    return (
        <Create title={translate('resources.schedules.create')} 
            resource={`schedules/entity/device/${id}`} 
            redirect={`/devices/${id}/schedules`}
            actions={<RecordActionsTabs subTabs={subTabs} resourceParent="devices" />} 
        >
            <ScheduleForm newRecord />
        </Create>
    )
}

export default ScheduleCreate